export default class TimeZone {
  constructor(
    timeZoneNumber = -1,
    description = '',
    offsetHour = 0,
    offsetMinute = 0
  ) {
    this.timeZoneNumber = timeZoneNumber
    this.description = description
    this.offsetHour = offsetHour
    this.offsetMinute = offsetMinute
  }

  mapFromApi(responseData) {
    this.timeZoneNumber = responseData.TimeZoneNumber
    this.description = responseData.Description
    this.offsetHour = responseData.OffsetHour
    this.offsetMinute = responseData.OffsetMinute
  }
}
